import { createEnum, requestState } from '../utils/actionTypesHelpers';

export default createEnum(
  {
    list: createEnum(requestState, 'psmAuditDigital.list'),
    getById: createEnum(requestState, 'psmAuditDigital.getById'),
    followUpGet: createEnum(requestState, 'psmAuditDigital.followUpGet'),
    followUpCreate: createEnum(requestState, 'psmAuditDigital.followUpCreate'),
    followUpUpdate: createEnum(requestState, 'psmAuditDigital.followUpUpdate'),
    followUpDelete: createEnum(requestState, 'psmAuditDigital.followUpDelete'),
    questions: createEnum(requestState, 'psmAuditDigital.questions'),
    create: createEnum(requestState, 'psmAuditDigital.create'),
    update: createEnum(requestState, 'psmAuditDigital.update'),
    remove: createEnum(requestState, 'psmAuditDigital.remove'),
    pendingCompanyRedirectSet: 'psmAuditDigital.pendingCompanyRedirectSet',
    pendingCompanyRedirectClear: 'psmAuditDigital.pendingCompanyRedirectClear',
    currentAuditClear: 'psmAuditDigital.currentAuditClear',
  },
  'psmAuditDigital',
);
